module.exports = "<div ui-view></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/outputManage/baseData/buyer/view/buyerTemplate.html
// module id = /l3e
// module chunks = 0